import type { ReactNode } from "react";

interface PageHeaderProps {
	title: string;
	description?: string;
	/** Right-aligned primary actions (usually a single button). */
	actions?: ReactNode;
	/** Small muted line above the title, e.g. a section name. */
	eyebrow?: string;
}

export function PageHeader({ title, description, actions, eyebrow }: PageHeaderProps) {
	return (
		<div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
			<div className="min-w-0">
				{eyebrow ? (
					<div className="mb-1 text-[11px] font-medium uppercase tracking-wider text-[var(--c-text-muted)]">
						{eyebrow}
					</div>
				) : null}
				<h1 className="m-0 truncate text-xl font-semibold tracking-[-0.01em] text-[var(--c-text)]">
					{title}
				</h1>
				{description ? (
					<p className="mt-1 mb-0 text-[13px] text-[var(--c-text-secondary)]">{description}</p>
				) : null}
			</div>
			{actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
		</div>
	);
}
